<!-- Оборачивает форму редактирования трекера телематики в базовую модалку -->
<template>
  <base-modal
    class="tracker-edit-modal"
    :visible="visible"
    title="Редактирование трекера"
    size="lg"
    @close="$emit('cancel')"
  >
    <TelemetryTrackerForm
      v-if="tracker"
      :initial-data="tracker"
      :is-loading="isLoading"
      @save="$emit('save', $event)"
      @cancel="$emit('cancel')"
    >
      <template #vehicle-display>
        <BaseEntityLink
          v-if="tracker.vehicle_id"
          route-name="VehicleDetails"
          :entity-id="tracker.vehicle_id"
          :title="vehicleTitle"
          new-tab
        >
          <template
            v-if="vehicleInfo?.registrationNumber"
            #icon
          >
            <VehicleRegNumberBadge
              :number="vehicleInfo.registrationNumber"
              size="sm"
            />
          </template>
        </BaseEntityLink>
        <span
          v-else
          class="vehicle-readonly-display vehicle-readonly-display--empty"
        >
          —
        </span>
      </template>
    </TelemetryTrackerForm>
  </base-modal>
</template>

<script>
import TelemetryTrackerForm from "@/components/Telemetry/TelemetryTrackerForm.vue";
import VehicleRegNumberBadge from "@/components/Vehicle/VehicleRegNumberBadge.vue";

export default {
  name: "TelemetryTrackerEditModal",

  components: {
    TelemetryTrackerForm,
    VehicleRegNumberBadge,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tracker: {
      type: Object,
      default: null,
    },
    vehicleInfo: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["save", "cancel"],

  computed: {
    vehicleTitle() {
      return (
        this.vehicleInfo?.displayName ||
        `Транспорт #${this.tracker.vehicle_id}`
      );
    },
  },
};
</script>

<style scoped>
.vehicle-readonly-display {
  font-size: 14px;
  color: var(--color-dark);
}

.vehicle-readonly-display--empty {
  color: #6b7280;
}
</style>
